export default __webpack_public_path__ + "static/media/Group 953@2x.48dfe7f0.png";